export default __webpack_public_path__ + "static/media/info.b89d7ba2.svg";